import "../SCSS/stylesMobile.css";
import { DateComponentProps } from "../DateAndTimeTypeProps";
import {
  DateFormatTypeEnum,
  DateTypeEnum,
  EnumSurveyAnswerStatus,
  RangeTypeEnum,
} from "../../../Common/Enums/EnumsTypes";
import { addDays, addYears } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import icons from "../../../Assets/Icons/icons";
function DateAndTimeMobileView({
  surveyAnswersInfo,
  questionId,
  surveyAnswers,
  isPreview,
  handleChangeDate,
  handleChangeFromAndTo,
}: DateComponentProps) {
  const dateInfo =
    surveyAnswersInfo.surveyInfo.questionsInfo.questionObj[questionId].dateInfo;

  function selectedDateValue(
    dateType: string,
    dateFormat: string | undefined,
    rangeType?: string
  ) {
    if (dateType === DateTypeEnum.DATE) {
      switch (dateFormat) {
        case DateFormatTypeEnum.DATE:
        case DateFormatTypeEnum.MONTH:
          return surveyAnswers?.[questionId]?.val
            ? new Date(surveyAnswers?.[questionId]?.val?.from ?? null)
            : null;
        case DateFormatTypeEnum.YEAR:
          return surveyAnswers?.[questionId]?.val
            ? new Date(surveyAnswers?.[questionId]?.val?.year ?? null)
            : null;
        default:
          return null;
      }
    } else {
      if (rangeType === RangeTypeEnum.FROM) {
        switch (dateFormat) {
          case DateFormatTypeEnum.DATE:
          case DateFormatTypeEnum.MONTH:
          case DateFormatTypeEnum.YEAR:
            return surveyAnswers?.[questionId]?.val?.from
              ? new Date(surveyAnswers?.[questionId]?.val?.from ?? null)
              : null;
          default:
            return null;
        }
      } else {
        switch (dateFormat) {
          case DateFormatTypeEnum.DATE:
          case DateFormatTypeEnum.MONTH:
          case DateFormatTypeEnum.YEAR:
            return surveyAnswers?.[questionId]?.val?.to
              ? new Date(surveyAnswers?.[questionId]?.val?.to ?? null)
              : null;
          default:
            return null;
        }
      }
    }
  }
  //date formater
  function dateFormatter(dateFormat: string | undefined) {
    switch (dateFormat) {
      case DateFormatTypeEnum.DATE:
        return "dd/MM/yyyy";
      case DateFormatTypeEnum.MONTH:
        return "MM/dd/yyyy";
      case DateFormatTypeEnum.YEAR:
        return "yyyy";
      default:
        return dateFormat;
    }
  }
  //label
  function dynamicLabelName(dateFormat: string) {
    switch (dateFormat) {
      case DateFormatTypeEnum.DATE:
        return "Date";
      case DateFormatTypeEnum.MONTH:
        return "Date";
      case DateFormatTypeEnum.YEAR:
        return "Year";
      default:
        return "";
    }
  }
  return (
    <div className="mobile-supplier-view-date-cover">
      <div className="mobile-date-view-mode-option-cover">
        {dateInfo?.dateType === DateTypeEnum.DATE && (
          <div>
            <div className="mobile-date-text">
              {dynamicLabelName(dateInfo?.dateFormat)}
            </div>
            <div className="mobile-date-picker-cover">
              <div className="mobile-date-picker">
                <DatePicker
                  className="mobile-date-input"
                  onKeyDown={(e) => e.preventDefault()}
                  dateFormat={dateFormatter(dateInfo?.dateFormat)}
                  onChange={(date) =>
                    surveyAnswersInfo?.surveyStatus !==
                      EnumSurveyAnswerStatus?.COMPLETED &&
                    handleChangeDate(date)
                  }
                  selected={
                    selectedDateValue(
                      surveyAnswersInfo.surveyInfo.questionsInfo.questionObj?.[
                        questionId
                      ]?.dateInfo?.dateType!,
                      surveyAnswersInfo.surveyInfo.questionsInfo.questionObj?.[
                        questionId
                      ]?.dateInfo?.dateFormat
                    ) ?? null
                  }
                  showYearPicker={
                    dateInfo?.dateFormat === DateFormatTypeEnum.YEAR
                  }
                  disabled={
                    isPreview ||
                    surveyAnswersInfo?.surveyStatus ===
                      EnumSurveyAnswerStatus?.COMPLETED
                  }
                />
              </div>

              <span className="mobile-calendar-icon">{icons.calendarIcon}</span>
            </div>
          </div>
        )}
        {dateInfo?.dateType === DateTypeEnum.RANGE && (
          <div className="mobile-date-from-to-cover">
            <div className="mobile-date-from-cover">
              <div className="mobile-date-text-from">From</div>
              <div className="mobile-date-picker-cover-from">
                <div className="mobile-date-picker">
                  <DatePicker
                    onKeyDown={(e) => e.preventDefault()}
                    className="mobile-date-input-from"
                    dateFormat={dateFormatter(dateInfo?.dateFormat)}
                    onChange={(date) =>
                      surveyAnswersInfo?.surveyStatus !==
                        EnumSurveyAnswerStatus?.COMPLETED &&
                      handleChangeFromAndTo(date, RangeTypeEnum.FROM)
                    }
                    selected={
                      selectedDateValue(
                        surveyAnswersInfo.surveyInfo.questionsInfo
                          .questionObj?.[questionId]?.dateInfo?.dateType!,
                        surveyAnswersInfo.surveyInfo.questionsInfo
                          .questionObj?.[questionId]?.dateInfo?.dateFormat,
                        RangeTypeEnum.FROM
                      ) ?? null
                    }
                    showYearPicker={
                      dateInfo?.dateFormat === DateFormatTypeEnum.YEAR
                    }
                    disabled={
                      isPreview ||
                      surveyAnswersInfo?.surveyStatus ===
                        EnumSurveyAnswerStatus?.COMPLETED
                    }
                  />
                </div>
                <span className="mobile-calendar-icon-from">
                  {icons.calendarIcon}
                </span>
              </div>
            </div>
            <div className="mobile-date-to-cover">
              <div className="mobile-date-text-to">To</div>
              <div className="mobile-date-picker-cover-to">
                <div className="mobile-date-picker">
                  <DatePicker
                    className="mobile-date-input-to"
                    onKeyDown={(e) => e.preventDefault()}
                    dateFormat={dateFormatter(dateInfo?.dateFormat)}
                    onChange={(date) =>
                      surveyAnswersInfo?.surveyStatus !==
                        EnumSurveyAnswerStatus?.COMPLETED &&
                      handleChangeFromAndTo(date, RangeTypeEnum.TO)
                    }
                    selected={
                      selectedDateValue(
                        surveyAnswersInfo.surveyInfo.questionsInfo
                          .questionObj?.[questionId]?.dateInfo?.dateType!,
                        surveyAnswersInfo.surveyInfo.questionsInfo
                          .questionObj?.[questionId]?.dateInfo?.dateFormat,
                        RangeTypeEnum.TO
                      ) ?? null
                    }
                    showYearPicker={
                      dateInfo?.dateFormat === DateFormatTypeEnum.YEAR
                    }
                    disabled={
                      !surveyAnswers?.[questionId]?.val?.from ||
                      surveyAnswersInfo?.surveyStatus ===
                        EnumSurveyAnswerStatus?.COMPLETED
                    }
                    minDate={
                      dateInfo?.dateFormat === DateFormatTypeEnum.YEAR
                        ? addYears(
                            new Date(surveyAnswers?.[questionId]?.val?.from),
                            1
                          )
                        : addDays(
                            new Date(surveyAnswers?.[questionId]?.val?.from),
                            1
                          )
                    }
                  />
                </div>
                <span className="mobile-calendar-icon-to">
                  {icons.calendarIcon}
                </span>
              </div>
              {surveyAnswers?.[questionId]?.val?.from &&
                !surveyAnswers?.[questionId]?.val?.to && (
                  <div className="mobile-to-date-validation">
                    Please fill the empty field
                  </div>
                )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DateAndTimeMobileView;
